import api from './api';

const budgetService = {
  // Get all budgets with filters
  getAllBudgets: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.project_id) params.append('project_id', filters.project_id);
    if (filters.category) params.append('category', filters.category);
    if (filters.fiscal_year) params.append('fiscal_year', filters.fiscal_year);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.sort_by) params.append('sort_by', filters.sort_by);
    if (filters.sort_order) params.append('sort_order', filters.sort_order);

    const response = await api.get(`/budgets?${params.toString()}`);
    return response.data;
  },

  // Get single budget
  getBudget: async (id) => {
    const response = await api.get(`/budgets/${id}`);
    return response.data;
  },

  // Create budget
  createBudget: async (data) => {
    const response = await api.post('/budgets', data);
    return response.data;
  },

  // Update budget
  updateBudget: async (id, data) => {
    const response = await api.put(`/budgets/${id}`, data);
    return response.data;
  },

  // Delete budget
  deleteBudget: async (id) => {
    const response = await api.delete(`/budgets/${id}`);
    return response.data;
  },

  // Get budget statistics by project
  getStatisticsByProject: async (projectId) => {
    const response = await api.get(`/budgets/project/${projectId}/statistics`);
    return response.data;
  },

  // Helper: Get budget categories
  getCategories: () => [
    { value: 'Labor', label: 'Labor', icon: '👥' },
    { value: 'Materials', label: 'Materials', icon: '📦' },
    { value: 'Equipment', label: 'Equipment', icon: '🔧' },
    { value: 'Software', label: 'Software', icon: '💻' },
    { value: 'Other', label: 'Other', icon: '📋' }
  ],

  // Helper: Get category color
  getCategoryColor: (category) => {
    const colors = {
      Labor: 'blue',
      Materials: 'green',
      Equipment: 'orange',
      Software: 'purple',
      Other: 'gray'
    };
    return colors[category] || 'gray';
  },

  // Helper: Get category icon
  getCategoryIcon: (category) => {
    const icons = {
      Labor: '👥',
      Materials: '📦',
      Equipment: '🔧',
      Software: '💻',
      Other: '📋'
    };
    return icons[category] || '📋';
  },

  // Helper: Format currency
  formatCurrency: (amount, currency = 'INR') => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  },

  // Helper: Calculate utilization percentage
  calculateUtilization: (allocated, spent) => {
    if (!allocated || allocated === 0) return 0;
    return Math.round((spent / allocated) * 100);
  },

  // Helper: Get utilization color
  getUtilizationColor: (percentage) => {
    if (percentage >= 90) return 'red';
    if (percentage >= 75) return 'orange';
    if (percentage >= 50) return 'yellow';
    return 'green';
  }
};

export default budgetService;


